import { render, staticRenderFns } from "./CustomerFacingTransactions.vue?vue&type=template&id=4b78eb22&"
import script from "./CustomerFacingTransactions.vue?vue&type=script&lang=js&"
export * from "./CustomerFacingTransactions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VDataTable})
